import { render, staticRenderFns } from "./VuesticPopover.vue?vue&type=template&id=ad00f652&scoped=true&"
import script from "./VuesticPopover.vue?vue&type=script&lang=js&"
export * from "./VuesticPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad00f652",
  null
  
)

export default component.exports